import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useLocation, useParams, Navigate, Outlet } from 'react-router-dom'
import WelcomePage from './components/WelcomePage'
import FourOhFour from './components/common/FourOhFour'
import { isFeatureEnabled } from './utility/featureEnablement'
import { getActiveCommunity } from './utility/activeCommunity'
import LogInPage from './components/auth/LogIn/LogInPage'

export const RootPage = ({ showSignUp = false }) => {
  const user = useSelector(state => state.user)

  if (user.length !== 0) {
    return <Navigate to='/dashboard' replace={true}/>
  }

  return <WelcomePage showSignUp={showSignUp} />
}

RootPage.propTypes = {
  showSignUp: PropTypes.bool,
}

export const AuthenticatedApp = ({ children }) => {
  const user = useSelector(state => state.user)
  const location = useLocation()

  if (user.length === 0) {
    localStorage.setItem('redirectUrl', location.pathname)
    return <Navigate to='/' replace={true}/>
  }

  return children
}

AuthenticatedApp.propTypes = {
  children: PropTypes.node,
}

const useAuthenticatedUser = () => {
  const current_user = useSelector(state => state.user.current_user)
  const user = { ...current_user }

  if (user.type === 'Student' && user.family_admin) {
    user.type = 'FamilyAdmin'
  }

  return user
}

const featureEnabled = (user, feature, activeCommunityId) => {
  if (isFeatureEnabled(getActiveCommunity(user, activeCommunityId), feature)) {
    return true
  }

  return false
}

export const AuthorizationRoute = ({ roles, leadCoachRequired, feature, profileAccess }) => {
  const user = useAuthenticatedUser()
  const { userId } = useParams()
  const activeCommunityId = useSelector(state => state.user.active_community_id)
  const profileForbidden = useSelector(state => state.user.profileForbidden)
  const isCoach = user.type === 'Coach'

  if (feature && !featureEnabled(user, feature, activeCommunityId)) {
    return <FourOhFour />
  }

  if (profileAccess) {
    const targetUserId = parseInt(userId)
    if (profileForbidden === targetUserId) { return <FourOhFour /> }
  }

  if (roles) {
    roles = [].concat(roles) // Ensure roles is array

    if (!roles.includes(user.type)) {
      return <FourOhFour />
    }
  }

  if (!isCoach) {
    return <Outlet />
  }

  if (leadCoachRequired && !user.lead_coach) {
    return <FourOhFour />
  }

  if (!user.user_settings) {
    return <LogInPage />
  }

  return <Outlet />
}

AuthorizationRoute.propTypes = {
  roles: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  leadCoachRequired: PropTypes.bool,
  feature: PropTypes.string,
  profileAccess: PropTypes.bool,
}
